var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.app.state != _vm.STATE.LOADED)?_c('pre-loader'):_vm._e(),_c('router-view'),_c('modal',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }